export default "__VITE_ASSET__Bvvd2nHj__"